import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export const LOW_COUNT_THRESHOLD = 2
export const DEFAULT_SKIPS_REMAINING = 5

export class RecoveryCodesStatus {
  codesRemaining = 0
  totalCodes = 0
  generatedAt: Date | null = null
  skipsRemaining = DEFAULT_SKIPS_REMAINING
  isTwoFactorEnabled = false

  isRunningLow(): boolean {
    if (this.generatedAt === null) {
      return false
    }
    return this.codesRemaining <= LOW_COUNT_THRESHOLD
  }
}

export const RECOVERY_CODES_STATUS_DESER: SchemaDeSer<RecoveryCodesStatus> =
  new SchemaDeSerBuilder(RecoveryCodesStatus)
    .ofInt("codesRemaining", { jsonField: "recovery-codes-remaining" })
    .ofInt("totalCodes", { jsonField: "recovery-codes-total" })
    .ofDateTime("generatedAt", "", "generated-at")
    .ofInt("skipsRemaining", {
      jsonField: "recovery-code-generation-skips-remaining",
    })
    .ofBoolean("isTwoFactorEnabled", "is-two-factor-enabled")
    .toDeSer()
